var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.13332 7.8555C1.50125 7.8555 0.988866 8.36789 0.988867 8.99996C0.988867 9.63202 1.50126 10.1444 2.13332 10.1444L7.85544 10.1444L7.85545 15.8668C7.85545 16.4988 8.36784 17.0112 8.9999 17.0112C9.63196 17.0112 10.1444 16.4988 10.1444 15.8668L10.1443 10.1444L15.8667 10.1444C16.4988 10.1444 17.0112 9.63203 17.0112 8.99997C17.0112 8.3679 16.4988 7.85551 15.8667 7.85551L10.1443 7.85551L10.1443 2.13333C10.1443 1.50127 9.63195 0.988882 8.99989 0.988881C8.36783 0.988881 7.85544 1.50127 7.85544 2.13333L7.85544 7.85551L2.13332 7.8555Z",
    fill: "#060817"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.48d684e25a62d658b113ecf0e0c6979c.svg";
export { ForwardRef as ReactComponent };